module.exports = __webpack_public_path__ + "ui-bg_flat_10_000000_40x100.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-bg_flat_10_000000_40x100.png
// module id = 815
// module chunks = 1